import styled from 'styled-components/macro';
import { Button } from 'ui-component-library';

import { FlexJustifyCenter, FlexNoAlign } from '../../../../../shared-styles/flex';
import { InfoSectionHeaderButton, InfoSectionHeaderButtonContainer } from '../../../../../shared-styles/info-section-header-button';

export const DateLabelContainer = styled.div`
  ${FlexNoAlign}
  align-items: center;
  padding-bottom: ${(props) => props.theme.spacing(5)};
`;

export const Label = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
  padding-bottom: ${(props) => props.theme.spacing(5)};
  color: ${(props) => (props.theme.palette.darkBlue[100])};
`;

export const DateLabel = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
  padding-left: ${(props) => props.theme.spacing(8)};
  color: ${(props) => (props.theme.palette.darkBlue[100])};
  margin-bottom: ${(props) => (props.marginBottom ? props.marginBottom : '0px')};
`;

export const DateTimeContainer = styled.div`
  display: grid;
  grid-template-columns: 40px auto;
`;

export const Text = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
`;

export const LateBadgeContainer = styled.div`
  margin-top: -${(props) => props.theme.spacing(5)};
  margin-left: ${(props) => props.theme.spacing(5)};
  background-color: ${(props) => props.theme.palette.orange[100]};
  border-radius: 8px;
`;

export const LocationRemarks = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
`;

export const NoRemarks = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
  color: ${(props) => props.theme.palette.black[50]};
`;

export const HeaderButtonsGroup = styled.div`
  ${InfoSectionHeaderButtonContainer}
`;

export const HeaderButton = styled(Button)`
  ${InfoSectionHeaderButton};
  max-height: 24px;
`;

export const EditContainer = styled.div`
  grid-column: 2 / span 3;
`;

export const ControlContainer = styled.div`
  padding-bottom: ${(props) => props.theme.spacing(10)};
`;

export const LoadingContainer = styled.div`
  ${FlexJustifyCenter};
`;
